<template>
  <!-- App -->
  <div id="app_f7">
  <div id="oruba-header">
    <img src="/static/oruba_header.png" style="float:left; display:block; margin-right:40px;margin-left:40px;margin-top:11px;" />
    <span id="cp_span" style="margin-top:8px; float:left; font-family: 'Catamaran'; font-size: 22px; font-style: normal; font-weight: 100; letter-spacing: 0.1em; color:white; text-transform: uppercase;">{{ $t("result_ui.control_panel") }}</span>
    <div id="ua-info" v-show="systemConfig.UAEnabled" style="float:right; margin-top:8px; text-align: right;">
      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && uaState == 'STANDBY'">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">checkmark</i></div>
        <div class="chip-label">{{ $t("urine_analysis.inalys_ready") }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && (uaState !== 'STANDBY' && uaState !== 'DISCONNECTED')">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">timer_fill</i></div>
        <div class="chip-label">{{ $t("urine_analysis.inalys_busy") }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="!connectionState||uaState == 'DISCONNECTED'">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">bolt_fill</i></div>
        <div class="chip-label">{{ $t("urine_analysis.inalys_connecting") }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && casetteState == -1">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">tape_fill</i></div>
        <div class="chip-label">{{ $t("urine_analysis.insert_casette") }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && casetteState !== -1 && nextStrip == -1">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">info_fill</i></div>
        <div class="chip-label">{{ $t("urine_analysis.waiting_strip_info") }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && casetteState !== -1 && nextStrip > 0 && nextStrip <= 3">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">circle_half</i></div>
        <div class="chip-label">{{ $t('urine_analysis.strips_remaining', {strips: nextStrip}) }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && casetteState !== -1 && nextStrip > 3">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">circle_fill</i></div>
        <div class="chip-label">{{ $t('urine_analysis.strips_remaining', {strips: nextStrip}) }}</div>
      </div>

      <div class="chip bg-blue" style="margin-right: 10px; padding:12px" v-show="connectionState && casetteState !== -1 && nextStrip === 0">
        <div class="chip-media" style="margin-right: 5px;"><i class="icon f7-icons">circle</i></div>
        <div class="chip-label">{{ $t("urine_analysis.casette_empty") }}</div>
      </div>

    </div>

  </div>
  <div class="dev-box-app" v-show="deviceHelper" style="position:absolute; width:200px; padding:5px; right:50px; top:50px; background-color:white; z-index:9999">
    <ul style="list-style-type: none; line-height:15px; margin-left:3px; padding:0">
      <li><input type="checkbox" id="checkbox1" v-model="systemConfig.AllowAddPatient"><label for="checkbox1">AllowAddPatient: {{ systemConfig.AllowAddPatient }}</label></li>
      <li><input type="checkbox" id="checkbox2" v-model="systemConfig.EMGEnabled"><label for="checkbox2">EMGEnabled: {{ systemConfig.EMGEnabled }}</label></li>
      <li><input type="checkbox" id="checkbox8" v-model="systemConfig.UAEnabled"><label for="checkbox8">UAEnabled: {{ systemConfig.UAEnabled }}</label></li>
      <li><input type="checkbox" id="checkbox3" v-model="systemConfig.PVREnabled"><label for="checkbox3">PVREnabled: {{ systemConfig.PVREnabled }}</label></li>
      <li><input type="checkbox" id="checkbox4" v-model="systemConfig.CommentEnabled"><label for="checkbox4">CommentEnabled: {{ systemConfig.CommentEnabled }}</label></li>
      <li><input type="checkbox" id="checkbox5" v-model="systemConfig.AllowRemovePatient"><label for="checkbox5">AllowRemovePatient: {{ systemConfig.AllowRemovePatient }}</label></li>
      <li><input type="checkbox" id="checkbox6" v-model="systemConfig.AllowRemoveExam"><label for="checkbox6">AllowRemoveExam: {{ systemConfig.AllowRemoveExam }}</label></li>
      <li><input type="checkbox" id="checkbox7" v-model="systemConfig.AllowEditPatient"><label for="checkbox7">AllowEditPatient: {{ systemConfig.AllowEditPatient }}</label></li>
      <li><u>AddPatientMode</u><b> {{ systemConfig.AddPatientMode }}</b></li>
      <li><a href="#" @click.prevent="systemConfig.AddPatientMode = 'Hospital'">Hospital</a></li>
      <li><a href="#" @click.prevent="systemConfig.AddPatientMode = 'Free'">Free</a></li>
      <li><a href="#" @click.prevent="systemConfig.AddPatientMode = 'type3'">type3</a></li>
      <li><a href="#" @click.prevent="systemConfig.AddPatientMode = 'Free2'">Free2</a></li>
      <li><u>Integration.Mode</u><b> {{ systemConfig['Integration.Mode'] }}</b></li>
      <li><a href="#" @click.prevent="systemConfig['Integration.Mode'] = 'MWL_PACS'">MWL_PACS</a></li>
      <li><a href="#" @click.prevent="systemConfig['Integration.Mode'] = 'MANUAL'">MANUAL</a></li>
      <li><u>PrintBarcodeType</u><b> {{ systemConfig['PrintBarcodeType'] }}</b></li>
      <li><a href="#" @click.prevent="systemConfig['PrintBarcodeType'] = 'type1'">type1</a></li>
      <li><a href="#" @click.prevent="systemConfig['PrintBarcodeType'] = 'type2'">type2</a></li>
      <li><a href="#" @click.prevent="systemConfig['PrintBarcodeType'] = 'type3'">type3</a></li>
      <li><u>Doctor</u><b> {{ systemConfig.Doctor && systemConfig.Doctor.length }}</b></li>
      <li><a href="#" @click.prevent="systemConfig.Doctor = []">[]</a></li>
      <li><a href="#" @click.prevent="systemConfig.Doctor = [{id:1, name_surname:'Sample Doctor'}]">Sample Doctor</a></li>
    </ul>
  </div>
        <f7-panel id="left" left  reveal layout="dark">

          <f7-block-title v-show="loggedUser.username">USER: {{ loggedUser.username }}</f7-block-title>

          <f7-list>
            <f7-list-item @click="settings" link="#" title="Device Settings"></f7-list-item> <!-- vm.$f7.popup('#maintenance')-->
            <f7-list-item v-show="loggedUser.auth" @click="changepassword" link="#" title="Change Password"></f7-list-item>
            <f7-list-item v-show="loggedUser.auth" @click="logout"  link="#" title="Logout"></f7-list-item>
          </f7-list>
          <!-- Left panel content goes here -->
        </f7-panel>

        <!-- Statusbar -->
        <f7-statusbar></f7-statusbar>

        <!-- Main Views -->
        <f7-views>
                <f7-view id="view-left" class="view-left" navbar-through :dynamic-navbar="true" name="left" data-view="view-left">
                  <!-- iOS Theme Navbar -->
                  <f7-navbar v-if="$theme.ios">
                    <f7-nav-left>
                      <!-- <f7-link open-popup="#maintenancePopup" icon-f7="settings"></f7-link> -->
                      <!-- <f7-link open-popover="#usermenu" icon-f7="person"></f7-link>  -->
                      <f7-link open-panel="#left" icon-f7="menu"></f7-link> <!--  open-login-screen="#login" open-login-screen=".maintenanceLogin" -->
                    </f7-nav-left>
                    <f7-nav-center sliding>{{ $t("result_ui.patient_list") }}</f7-nav-center>
                    <f7-nav-right v-show="systemConfig.AllowAddPatient">
                      <f7-link v-show="systemConfig.AddPatientMode == 'Hospital'" open-popup="#addNewPopupHospital" icon-f7="add_round"></f7-link>
                      <f7-link v-show="systemConfig.AddPatientMode == 'Free'" open-popup="#addNewPopupFree" icon-f7="add_round"></f7-link>
                      <f7-link v-show="systemConfig.AddPatientMode == 'type3'" open-popup="#addNewPopupType3" icon-f7="add_round"></f7-link>
                      <f7-link v-show="systemConfig.AddPatientMode == 'Free2'" open-popup="#addNewPopupFree2" icon-f7="add_round"></f7-link>
                    </f7-nav-right>
                    <f7-nav-right v-show="!systemConfig.AllowAddPatient"></f7-nav-right>
                  </f7-navbar>
                  <!-- Pages -->
                  <f7-pages>
                    <!-- Left Panel with Reveal effect -->

                    <f7-page infinite-scroll :infinite-scroll-preloader="(showPreloader && showPatientList) || (searchBusy && !showPatientList)" @infinite="onInfinite">
                      <f7-popup id="addNewPopupType3">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.new_patient') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="createPatientType3">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.patient_number') }}</f7-label>
                                      <f7-input v-model="newPatient.hastaNo" type="text" :placeholder="$t('result_ui.patient_number')"/>
                                    </f7-list-item>
                                  </f7-list>

                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="addComment" @popup:open="comment = exam_detail.comment">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup="#addComment">{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('report.comments') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="saveComment">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.comments') }}</f7-label>
                                      <f7-input type="textarea" v-model="comment" placeholder="Lütfen yorum yazınız"></f7-input>
                                    </f7-list-item>
                                    <!-- Text Input -->
                                  </f7-list>
                                  <f7-list form>
                                    <f7-list-item :title="$t('report.max_flow_rate')" :after="exam_detail.max_speed + ' ml/s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.time_to_max_flow')" :after="exam_detail.max_speed_time + ' s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.voided_volume')" :after="exam_detail.total_volume + ' ml'"></f7-list-item>
                                    <f7-list-item :title="$t('report.max_flow_rate')" :after="exam_detail.max_speed + ' ml/s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.voiding_time')" :after="exam_detail.duration + ' s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.flow_time')" :after="exam_detail.flow_time + ' s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.avg_flow_rate')" :after="exam_detail.average_speed + ' ml/s'"></f7-list-item>
                                    <f7-list-item :title="$t('report.delay_time')" :after="exam_detail.delay_time + ' s'"></f7-list-item>
                                    <f7-list-item v-show="exam_detail.pvr && systemConfig.PVREnabled" :title="$t('report.pvr')" :after="exam_detail.pvr + ' ml'"></f7-list-item>
                                  </f7-list>
                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="addNewPopupFree">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.new_patient') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="createPatient">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.name') }}</f7-label>
                                      <f7-input v-model="newPatient.name" type="text" :placeholder="$t('result_ui.name')"/>
                                    </f7-list-item>
                                    <!-- Password -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.surname') }}</f7-label>
                                      <f7-input v-model="newPatient.surname" type="text" :placeholder="$t('result_ui.surname')"/>
                                    </f7-list-item>
                                    <!-- Select -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.sex') }}</f7-label>
                                      <f7-input v-model="newPatient.gender" type="select">
                                        <option value="0">{{ $t('report.female') }}</option>
                                        <option value="1">{{ $t('report.male') }}</option>
                                      </f7-input>
                                    </f7-list-item>
                                    <!-- Switch -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.birth_date') }}</f7-label>
                                      <f7-input v-model="newPatient.birthDate" name="date" type="date" placeholder="Birth date" value=""></f7-input>
                                    </f7-list-item>
                                  </f7-list>

                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="addNewPopupFree2">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left>
                                      <f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link>
                                    </f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.new_patient') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="createPatientFree2">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.patient_id') }}</f7-label>
                                      <f7-input v-model="newPatient.hastaNo" @blur.stop="fetchPatient" type="number" :placeholder="$t('result_ui.patient_id')"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.name') }}</f7-label>
                                      <f7-input v-model="newPatient.name" type="text" :placeholder="$t('result_ui.name')"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.surname') }}</f7-label>
                                      <f7-input v-model="newPatient.surname" type="text" :placeholder="$t('result_ui.surname')"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.sex') }}</f7-label>
                                      <f7-input v-model="newPatient.gender" type="select">
                                        <option value="0">{{ $t('report.female') }}</option>
                                        <option value="1">{{ $t('report.male') }}</option>
                                      </f7-input>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.birth_date') }}</f7-label>
                                      <f7-input v-model="newPatient.birthDate" name="date" type="date" placeholder="Birth date" value=""></f7-input>
                                    </f7-list-item>
                                  </f7-list>

                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="addNewPopupHospital">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.new_exam') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="createPatientHospital">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.patient_id') }}</f7-label><!-- {{ a }} -->
                                      <f7-input v-model="newPatient.hastaNo" @blur.stop="fetchPatient" type="number" :placeholder="$t('result_ui.patient_id')"/>
                                    </f7-list-item>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.protocol_no') }}</f7-label>
                                      <f7-input v-model="newPatient.protokolNo" type="number" :placeholder="$t('result_ui.protocol_no')"/>
                                    </f7-list-item>
                                    <!-- Text Input -->
                                    <f7-list-item v-show="systemConfig.Doctor && systemConfig.Doctor.length">
                                      <f7-label>{{ $t('result_ui.doctor') }}</f7-label>
                                      <f7-input type="select" v-model="newPatient.doctor">
                                        <option value="-1" selected>{{ $t('result_ui.please_select_a_doctor') }}</option>
                                        <option v-for="doctor in systemConfig.Doctor" :value="doctor.id" :key="doctor.id">{{ doctor.name_surname }}</option>
                                      </f7-input>
                                    </f7-list-item>
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.name_surname') }}</f7-label>
                                      <f7-input :disabled="newPatientForm.patientDisabled" ref="ns" v-model="newPatient.nameSurname" type="text" :placeholder="newPatientForm.nsPlaceholder"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.sex') }}</f7-label>
                                      <f7-input :disabled="newPatientForm.patientDisabled" type="select" v-model="newPatient.gender">
                                        <option value="1" selected>{{ $t('report.male') }}</option>
                                        <option value="0" selected>{{ $t('report.female') }}</option>
                                      </f7-input>
                                    </f7-list-item>
                                    <!-- Select -->
                                    <!--
                                    <f7-list-item>
                                      <f7-label>Cinsiyet</f7-label>
                                      <f7-input v-model="newPatient.gender" type="select">
                                        <option value="0">Kadın</option>
                                        <option value="1">Erkek</option>
                                      </f7-input>
                                    </f7-list-item>
                                    -->
                                    <!-- Switch -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.birth_date') }}</f7-label>
                                      <f7-input :disabled="newPatientForm.patientDisabled" v-model="newPatient.birthDate" name="date" type="date" placeholder="Birth date" value=""></f7-input>
                                    </f7-list-item>
                                  </f7-list>

                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="startExamSelection">
                            <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.new_exam') }}</f7-nav-center>
                                  </f7-navbar>
                                  <f7-label style="text-align: center; margin-top: 15px; font-size: 15px;">{{ $t("result_ui.choose_exam_type") }}</f7-label>
                                  <f7-list v-show="systemConfig['Integration.Mode'] == 'MWL_PACS'">
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.barcode_no') }}</f7-label>
                                      <f7-input v-model="barcodeNumber" type="number" :placeholder="$t('result_ui.barcode_no')"/>
                                    </f7-list-item>
                                  </f7-list>

                                  <f7-list inset>
                                    <f7-list-button @click="startExam('URO')">{{ $t('result_ui.start_uroflowmetry') }}</f7-list-button>
                                  </f7-list>
                                  <f7-list v-show="systemConfig.UAEnabled" inset>
                                    <f7-list-button @click="startExam('UROUA')">{{ $t('result_ui.start_uroflowmetry_ua') }}</f7-list-button>
                                  </f7-list>
                                  <f7-list v-show="systemConfig.EMGEnabled" inset>
                                    <f7-list-button @click="startExam('UROEMG')">{{ $t('result_ui.start_uroflowmetry_emg') }}</f7-list-button>
                                  </f7-list>
                                  <f7-list inset v-show="systemConfig['Integration.Mode'] !== 'MWL_PACS' && systemConfig.EMGEnabled">
                                    <f7-list-button @click="startExam('BIO-0')">{{ $t('result_ui.start_biofeedback') }}</f7-list-button>
                                  </f7-list>
                                  <f7-list form inset v-show="systemConfig['Integration.Mode'] !== 'MWL_PACS' && systemConfig.EMGEnabled">
                                    <!-- Text Input -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.resistance_time') }}</f7-label>
                                      <f7-input v-model="direnme.direnmeZamani" type="number" />
                                    </f7-list-item>
                                    <!-- Password -->
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.rest_time') }}</f7-label>
                                      <f7-input v-model="direnme.dinlenimZamani" type="number" />
                                    </f7-list-item>
                                    <f7-list-button @click="startExam('BIO-1')">{{ $t('result_ui.resistance_biofeedback') }}</f7-list-button>

                                  </f7-list>

                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-popup id="editPatient">
                        <f7-view>
                              <f7-pages>
                                <f7-page navbar-fixed>
                                  <f7-navbar>
                                    <f7-nav-left><f7-link close-popup>{{ $t('result_ui.cancel') }}</f7-link></f7-nav-left>
                                    <f7-nav-center>{{ $t('result_ui.edit') }}</f7-nav-center>
                                    <f7-nav-right>
                                      <f7-link @click="updatePatient">{{ $t('result_ui.save') }}</f7-link>
                                    </f7-nav-right>
                                  </f7-navbar>
                                  <f7-list form>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.name') }}</f7-label>
                                      <f7-input v-model="patient.name" type="text" :placeholder="$t('result_ui.name')"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.surname') }}</f7-label>
                                      <f7-input v-model="patient.surname" type="text" :placeholder="$t('result_ui.surname')"/>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('report.sex') }}</f7-label>
                                      <f7-input v-model="patient.gender" type="select">
                                        <option value="0">{{ $t('report.female') }}</option>
                                        <option value="1">{{ $t('report.male') }}</option>
                                      </f7-input>
                                    </f7-list-item>
                                    <f7-list-item>
                                      <f7-label>{{ $t('result_ui.birth_date') }}</f7-label>
                                      <f7-input v-model="patient.birthDate" type="date"></f7-input>
                                    </f7-list-item>
                                  </f7-list>
                                </f7-page>
                              </f7-pages>
                            </f7-view>
                      </f7-popup>

                      <f7-searchbar
                        :cancel-link="$t('result_ui.cancel')"
                        @searchbar:search="onSearch"
                        @searchbar:clear="onClear"
                        @searchbar:disable="onDisable"
                        @searchbar:enable="onEnable"
                        :placeholder="$t('result_ui.patient_search')"
                        search-list="#patient-list"
                        :clear-button="true"
                        :custom-search="false"
                      ></f7-searchbar>
                      <!-- :link="'/patient-exam-list/' + p.id"
                      link-view=".view-main"
                      :link-reload="true" -->
                      <!-- <f7-list v-show="showPatientList">
                        <f7-list-item  :link="true" title="Yeni çalışma başlat"></f7-list-item>
                      </f7-list> -->

                      <f7-list v-show="showPatientList && systemConfig['Integration.Mode'] == 'MWL_PACS' && systemConfig['EMGEnabled']">
                        <f7-list-button @click="startExam">{{ $t('result_ui.new_exam') }}</f7-list-button>
                      </f7-list>

                      <f7-list media-list id="patient-list" v-show="showPatientList">
                        <f7-list-item v-for="p in patients" :key="p.id"
                          :title="p.name + ' ' + p.surname"
                          :subtitle="$t('result_ui.last_exam') + ': ' + (p.LastExamCreated || '-')"
                          :link="true"
                          @click="getExamList(p.id, p.name + ' ' + p.surname, p.value1)"
                          :class="{ 'selectedPatient': selectedPatient == p.id}"

                        >
                        </f7-list-item>
                      </f7-list>

                      <f7-list media-list id="found-patient-list" v-show="!showPatientList">
                        <f7-list-item v-for="p in foundPatients" :key="p.id"
                          :title="p.name + ' ' + p.surname"
                          :subtitle="$t('result_ui.last_exam') + ': ' + (p.LastExamCreated || '-')"
                          :link="true"
                          @click="getExamList(p.id, p.name + ' ' + p.surname, p.value1)"
                          :class="{ 'selectedPatient': selectedPatient == p.id}"

                        >
                        </f7-list-item>
                      </f7-list>

                      <f7-list v-show="!searchBusy && !showPatientList && !foundPatients.length && showMinCharLimit">
                        <f7-list-item :title="$t('result_ui.at_least')"></f7-list-item>
                      </f7-list>

                       <f7-list v-show="!searchBusy && !showPatientList && !foundPatients.length && !showMinCharLimit">
                        <f7-list-item :title="$t('result_ui.no_record')"></f7-list-item>
                      </f7-list>

                    </f7-page>
                  </f7-pages>
                </f7-view>
                <f7-view id="main-view" navbar-through :dynamic-navbar="true" main>
                  <!-- iOS Theme Navbar -->
                  <f7-navbar v-if="$theme.ios">
                    <f7-nav-left sliding>
                      <f7-link v-show="systemConfig['AllowEditPatient'] && systemConfig['Integration.Mode'] == 'MANUAL' && systemConfig['AddPatientMode'] !== 'type3' && selectedPatient !== -1" open-popup="#editPatient"
                                @click="getPatientInfo(selectedPatient)"
                                icon-f7="person_alt">&nbsp;&nbsp;{{ $t('result_ui.edit') }}</f7-link>
                    </f7-nav-left>
                    <f7-nav-center sliding>{{ $t("result_ui.examination_history") }}</f7-nav-center>
                    <f7-nav-right sliding><a @click="deviceScreen()" href="#">{{ $t("result_ui.device_screen") }} >></a></f7-nav-right>
                  </f7-navbar>
                  <!-- Pages link-open-popup="#chartPopup"-->
                  <f7-pages>
                    <f7-page>
                      <f7-block-title></f7-block-title>
                      <!-- <f7-block>{{ selectedPatientStr ? (exams.length ? selectedPatientStr + ' için ' + exams.length + ' çalışma listeleniyor:' : selectedPatientStr + ' için herhangi bir çalışma bulunamadı') : $t("result_ui.please_select_a_patient") }}</f7-block> -->
                      <f7-block>
                        <!-- <f7-link @click="$f7.mainView.router.load({url: '/maintenance/'})">About</f7-link> -->
                        {{ selectedPatientStr ? (exams.length ? $t('result_ui.exam_list_for_patient', {patient: selectedPatientStr, nof_exams: exams.length}) : $t('result_ui.no_exams_for_patient', {patient: selectedPatientStr})) : $t("result_ui.please_select_a_patient") }}
                      </f7-block>
                      <!-- Popup -->
                      <f7-list media-list>
                        <f7-list-item v-for="(e, ix) in exams" :key="e.id"
                          :link="true"
                          @click="showChart(e)"
                          :title="$t('result_ui.nth_exam', {nth: (exams.length - ix)})"
                          :after="e.created"

                        >
                        <!-- <span style="font-size:14px; color:#808080" slot="inner">{{ e.created }}</span> -->
                        </f7-list-item>
                        <!-- <f7-list-label>List Label</f7-list-label> -->
                      </f7-list>

                      <f7-block v-show="(systemConfig.AddPatientMode == 'Free'  || systemConfig.AddPatientMode == 'Free2') && systemConfig.AllowAddPatient && systemConfig['Integration.Mode'] == 'MANUAL' && selectedPatient !== -1"><span style="color:black; font-weight:bold;">Barkod no: {{ selectedPatient }}</span></f7-block>
                      <f7-block v-show="systemConfig['Integration.Mode'] !== 'MWL_PACS' && systemConfig.AllowAddPatient && (systemConfig.AddPatientMode == 'Free'  || systemConfig.AddPatientMode == 'Free2')"><f7-link @click="startExam">{{ selectedPatientStr ? '>> ' + $t('result_ui.start_exam_for_patient', {patient: selectedPatientStr}) + ' >>': '' }}</f7-link></f7-block>
                      <f7-block v-show="systemConfig['Integration.Mode'] !== 'MWL_PACS' && systemConfig.AllowAddPatient && systemConfig.AddPatientMode == 'type3'"><f7-link @click="startExamType3">{{ selectedPatientStr ? '>> ' + $t('result_ui.start_exam_for_patient', {patient: selectedPatientStr}) + ' >>': '' }}</f7-link></f7-block>

                      <f7-block v-show="systemConfig['Integration.Mode'] !== 'MWL_PACS' && systemConfig.AllowAddPatient && (systemConfig.AddPatientMode == 'Free' || systemConfig.AddPatientMode == 'type3' || systemConfig.AddPatientMode == 'Free2')">
                        <f7-link v-show="systemConfig.PrintBarcodeType == 'type1'" @click="printBarcode">{{ selectedPatientStr ? '>> ' + $t('result_ui.print_barcode_for_patient', {patient: selectedPatientStr}) + ' >>': '' }}</f7-link>
                        <f7-link v-show="systemConfig.PrintBarcodeType == 'type2'" @click="printBarcodePopup">{{ selectedPatientStr ? '>> ' + $t('result_ui.print_barcode_for_patient', {patient: selectedPatientStr}) + ' >>': '' }}</f7-link>
                      </f7-block>

                      <f7-block v-show="systemConfig.AddPatientMode == 'Hospital' && systemConfig.AllowAddPatient && systemConfig['Integration.Mode'] == 'MANUAL' && selectedPatient !== -1 && barcodes != ''">
                        <span style="color:black; font-weight:bold;">
                          {{ $t("result_ui.unused_barcodes") }}</span>
                          <div v-for="value in barcodes" :key="value">
                            {{ value.protokol_no }}
                          </div>
                      </f7-block>

                      <f7-block v-show="systemConfig.AllowRemovePatient && selectedPatient">
                        <f7-link color="red" @click="removePatient"> {{ selectedPatientStr ? '>> ' + $t('result_ui.remove_patient', {patient: selectedPatientStr}) + ' >>': '' }}</f7-link>
                        <f7-block-title>&nbsp;</f7-block-title>
                        <f7-block-title>&nbsp;</f7-block-title>
                      </f7-block>

                      <f7-popup tablet-fullscreen id="chartPopup" @popup:closed="chartPopupClosed" style="background-color:rgba(255, 255, 255, 0); padding-top:80px; direction: ltr;">
                        <!--   style="width:900px; margin-left:-450px;" -->
                        <div style="background-color:#fff; display: flex; flex-direction:column; align-items:center; width:900px; margin:0 auto; padding-top:20px; padding-bottom:20px;">

                          <div style="width:100%; padding-bottom:10px; margin:0 auto; clear:both;">
                            <div style="width:40%; padding-left:120px; text-align:left; float:left; display:none">
                            <vue-clip :options="options" :on-total-progress="totalProgress" :on-complete="complete">
                              <template slot="clip-uploader-action">
                                <div>
                                  <div class="dz-message"><f7-link>Entegre rapor için .ASC dosyası yükle</f7-link></div>
                                </div>
                              </template>
                              <template slot="clip-uploader-body"> <!-- scope="props" -->
                                <!-- <div v-for="file in props.files">
                                  <img v-bind:src="file.dataUrl" />
                                  {{ file.name }} {{ file.status }}
                                </div> -->
                              </template>
                            </vue-clip>
                                  <!-- <form id="fileSender" action="http://localhost:6161/upload" method="post" enctype="multipart/form-data">
                                    <input type="file" id="files" name="upload" style="visibility:hidden; width:0px;" @change="getFileName($event)" />
                                    <label for="files" style="color:#007aff; cursor:pointer">{{ filename }}</label>
                                    <input type="submit" v-if="fileSelected" value="Rapor oluştur" />
                                  </form> -->
                            </div>

                            <div v-show="!exam_detail.pvr && systemConfig.PVREnabled">
                              <f7-input v-model="pvr" type="number" :placeholder="$t('result_ui.enter_pvr')" style="width:170px; padding-left:120px; text-align:left; float:left; padding-right:0px !important;"/>
                              <f7-link :disabled="pvrBusy" style="width:100px; text-align:left; float:left; margin-left:25px;" @click="savePVR()">{{ $t('result_ui.save') }}</f7-link>
                            </div>

                            <div class="exam-links">
                              <f7-link v-show="systemConfig.CommentEnabled" open-popup="#addComment">{{ $t('report.comments') }}</f7-link>
                              <f7-link :disabled="systemConfig.PVREnabled && pvrBusy" @click="printPdf()">{{ $t('result_ui.print') }}</f7-link>
                              <f7-link :disabled="systemConfig.PVREnabled && pvrBusy" close-popup="#chartPopup">{{ $t('result_ui.close') }}</f7-link>
                              <f7-link v-show="systemConfig.AllowRemoveExam" :disabled="systemConfig.PVREnabled && pvrBusy" @click="removeExam" close-popup="#chartPopup" color='red'>{{ $t('result_ui.delete') }}</f7-link>
                            </div>
                          </div>

                          <svg id="chartHistory"></svg>
                          <div style="padding:15px; padding-left:15px; padding-bottom:15px; width:70%; margin:0 auto; clear:both;" v-show="show_uroflowmetry">
                            <table style="float: left;">
                              <tbody>
                                <tr>
                                  <td>{{ $t('report.max_flow_rate') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.max_speed }} ml/s</td>
                                </tr>
                                <tr>
                                  <td>{{ $t('report.time_to_max_flow') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.max_speed_time }} s</td>
                                </tr>
                                <tr>
                                  <td>{{ $t('report.voided_volume') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.total_volume }} ml</td>
                                </tr>
                                <tr v-show="exam_detail.pvr && systemConfig.PVREnabled">
                                  <td>{{ $t('report.pvr') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.pvr }} ml</td>
                                </tr>
                              </tbody>
                            </table>
                            <table style="float:right;">
                              <tbody>
                                <tr>
                                  <td>{{ $t('report.voiding_time') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.duration }} s</td>
                                </tr>
                                <tr>
                                  <td>{{ $t('report.flow_time') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.flow_time }} s</td>
                                </tr>
                                <tr>
                                  <td>{{ $t('report.avg_flow_rate') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.average_speed }} ml/s</td>
                                </tr>
                                <tr>
                                  <td>{{ $t('report.delay_time') }}</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.delay_time }} s</td>
                                </tr>
                                <!-- <tr>
                                  <td>Test tarihi</td>
                                  <td>:</td>
                                  <td>{{ exam_detail.created }}</td>
                                </tr> -->
                              </tbody>
                            </table>
                            <div v-show="exam_detail.comment" style="float: left; clear:both; margin-top:10px;"><u>{{ $t('report.comments') }}</u>: {{ exam_detail.comment }}</div>
                            <div v-show="exam_detail.ua_status" style="float: left; clear:both; margin-top:10px; background-color: yellow;">
                              <div v-if="exam_detail.ua_status === 'LOW_VOLUME'">
                                {{ $t('urine_analysis.low_volume', {volume: 100}) }}
                              </div>
                              <div v-if="exam_detail.ua_status === 'IN_PROGRESS'">
                                {{ $t('urine_analysis.in_progress') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </f7-popup>
                    </f7-page>
                  </f7-pages>
                </f7-view>
        </f7-views>

        <Maintenance></Maintenance>
        <Login class="parent" @success="loginSuccess"></Login>
        <ChangePassword class="parent"></ChangePassword>
  </div>
</template>

<script>
/* eslint-disable */
// import 'framework7/dist/css/framework7.ios.min.css'
// import 'framework7/dist/css/framework7.ios.colors.min.css'

import ReactiveDictClient from './ReactiveDictClient'
import GenericChart from './GenericChart'
import Settings from './settings'
// import Maintenance from './components/Maintenance'
import Maintenance from './components/Maintenance'
import Login from './components/Login'
import ChangePassword from './components/ChangePassword'
import { setTimeout } from 'timers'

const printurl = 'http://localhost:9191/print'
const apiurl = 'http://' + Settings.host + ':6161/api'
const actionurl = 'http://' + Settings.host + ':6161/action'
const staticurl = 'http://' + Settings.host + ':6161/static'

function isValidDate (dateString) {
    // First check for the pattern
  var regexDate = /^\d{4}-\d{1,2}-\d{1,2}$/

  if (!regexDate.test(dateString)) {
    return false
  }

    // Parse the date parts to integers
  var parts = dateString.split('-')
  var day = parseInt(parts[2], 10)
  var month = parseInt(parts[1], 10)
  var year = parseInt(parts[0], 10)

    // Check the ranges of month and year
  if (year < 1000 || year > 3000 || month === 0 || month > 12) {
    return false
  }

  var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ]

    // Adjust for leap years
  if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
    monthLength[1] = 29
  }

    // Check the range of the day
  return day > 0 && day <= monthLength[month - 1]
}

var loading = false
var searchTimeout

const wsurl = (path) => 'ws://' + Settings.host + ':6161' + path

export default {
  components: {
    Maintenance,
    Login,
    ChangePassword
  },
  data () {
    return {
      deviceHelper: false,
      page: undefined,
      showPreloader: false,
      showPatientList: true,
      showMinCharLimit: true,
      searchBusy: false,
      items: (function () {
        var it = []
        for (var i = 0; i < 25; i++) it.push(i + 1)
        return it
      })(),
      a: undefined,
      options: {
        url: '//localhost:6161/upload',
        paramName: 'upload'
      },
      systemConfig: {},
      foundPatients: [],
      patients: [],
      exam_detail: {max_speed: undefined, max_speed_time: undefined, total_volume: undefined, duration: undefined, flow_time: undefined, delay_time: undefined, average_speed: undefined, created: undefined, pvr: undefined, comment: undefined},
      selectedPatient: -1,
      selectedPatientNo: -1,
      selectedPatientStr: '',
      exams: [],
      barcodes: [],
      filename: 'Rapor için .ASC dosyası seçiniz',
      fileSelected: false,
      pvr: undefined,
      comment: undefined,
      pvrBusy: false,
      direnme: {direnmeZamani: 5, dinlenimZamani: 15},
      newPatient: {nameSurname: '', gender: 1, birthDate: '', protokolNo: undefined, doctor: -1, hastaNo: undefined},
      newPatientForm: {patientDisabled: true, nsPlaceholder: this.$t('result_ui.first_patient_id')},
      loggedUser: {},
      show_uroflowmetry: true,
      barcodeNumber: '',
      patient: {name: '', surname: '', gender: '', birthDate: ''},
      connectionState: false,
      uaState: 'DISCONNECTED',
      casetteState: -1,
      nextStrip: -1
      // loginInfo: {username: '', password: ''}
    }
  },
  created () {
    var vm = this

    // document.getElementById('cp_span').innerHTML = vm.$t('result_ui.control_panel')
    window.document.title = 'ORUFLOW - ' + vm.$t('result_ui.control_panel')

    vm.loggedUser = '{"auth": "", "scope":[], username: ""}'
    var _loggedUser = localStorage.getItem('user')
    if (_loggedUser) { vm.loggedUser = JSON.parse(_loggedUser) }

    vm.$http.get(apiurl + '/config').then(
      response => {
        vm.systemConfig = response.body

        // if (vm.systemConfig['UAEnabled']) {
        //   document.getElementById('ua-info').style.display = 'block'
        // }
      },
      response => {
        console.log('Getting config was failed.')
        if (response.status === 401) { vm.$f7.loginScreen('#login', true) }
      })

    vm.page = 1

    vm.$http.get(apiurl + '/patients_paged/' + vm.page).then(response => {
      vm.patients = response.body.data// .splice(0, 40)
      vm.page++
    }, response => {
      console.log('Error fetching patients')
    })

    console.log('App_f7.vue / created ()')
  },
  mounted () {
    var vm = this
    vm.deviceHelper = Settings.deviceHelper
    console.log('App_f7.vue / mounted ()')

    var addr = wsurl('/websocket')

    var db = new ReactiveDictClient(addr)

    vm.connectionState = false

    db.on('Urinalysis/ua_state', function (isnp, val) {
      vm.uaState = val
      console.log('ua_state', isnp, val)
    })

    db.on('Urinalysis/casette_state', function (isnp, val) {
      vm.casetteState = val
      console.log('casette_state', isnp, val)
    })

    db.on('Urinalysis/current_strip', function (isnp, val) {
      vm.nextStrip = val - 1
      console.log('current_strip', isnp, val)
      console.log('nextStrip', isnp, vm.nextStrip)
    })

    db.on('connecting', function () {
      vm.connectionState = false
      // vm.uiState = 'CONNECTING'
      // vm.debug = '...'
    })

    db.on('connected', function () {
      vm.connectionState = true
      // vm.$http.get(apiurl + '/config').then(
      //   response => {
      //     vm.systemConfig = response.body
      //     console.log('systemConfig arrived', response.body)
      //     vm.startTimeout = parseInt(vm.systemConfig.StartUrination, 10)
      //     if (vm.systemConfig.DeviceModel === 'i') {
      //       animationPath.barcode = pathBarcodei + '?' + Math.random()
      //     } else if (vm.systemConfig.DeviceModel === 'h') {
      //       animationPath.barcode = pathBarcodeh + '?' + Math.random()
      //     } else {
      //       console.log('Error getting device model and setting animation')
      //     }
      //     console.log(animationPath.barcode)

      //     let defaultEMGScale = vm.systemConfig['EMG.Chart.Scale']
      //     let selectElement = document.getElementById('emgScale')
      //     let options = Array.from(selectElement.options)
      //     let newDomain = defaultEMGScale.uV[1]

      //     let existingOption = options.find(option => option.value === String(newDomain))
      //     if (!existingOption) {
      //       const newOption = document.createElement('option')
      //       newOption.value = newDomain
      //       newOption.textContent = newDomain

      //       selectElement.insertBefore(newOption, selectElement.firstChild)
      //     }
      //   },
      //   error => {
      //     console.log('Error getting device model and setting animation, network level')
      //     console.dir(error)
      //     console.log(error.status)
      //     console.log(error.statusText)
      //   })
      // vm.debug = '.'
    })

    db.on('disconnected', function () {
      vm.connectionState = false
    })

    db.connect()


  },
  methods: {
    changepassword () {
      var _user = localStorage.getItem('user') || '{}'
      var user = JSON.parse(_user)
      console.log(user)
      console.log(user.scope)
      this.$f7.closePanel()
      this.$f7.popup('#changepassword', true)
    },
    settings () {
      var vm = this
      if (!vm.loggedUser.auth) { this.$f7.loginScreen('#login', true); return }

      if (vm.loggedUser.scope.includes('Settings')) {
        this.$f7.closePanel()
        this.$f7.popup('#maintenance', true)
        return
      }
      this.$f7.alert(
        'You don\'t have permission.',
        'Error'
      )
      this.$f7.closePanel()
    },
    logout () {
      var vm = this

      console.log('logging out..')
      localStorage.removeItem('user')
      vm.$http.get(apiurl + '/logout').then(response => {
        console.log('Logout success', response)
        this.$f7.closePanel()
        location.reload()
      }, response => {
        console.log('Logout error', response)
        this.$f7.closePanel()
        location.reload()
      })
    },
    fetchToken () {
      var vm = this

      // var data = {client_id: 'clientA',
      //   grant_type: 'john',
      //   username: 'password',
      //   password: 'doe',
      //   scope: 'calendar'}

      vm.$http.post('http://localhost:6161/token', 'data').then(response => {
        console.log('SUCCESS fetchToken')
        console.log(response)
      }, response => {
        console.log('FAIL fetchToken')
        console.log(response)
      })
    },
    onF7Init () {
      var vm = this
      window.f7 = this
      // vm.$f7.showPreloader()
      if (Settings.mAutoLogin) { vm.$f7.loginScreen('#login', false) }
    },
    loginSuccess: function () {
      // var vm = this
      console.log('login successful')
      location.reload()
    },
    onSearch: function (query, found) {
      var vm = this

      if (searchTimeout) { clearTimeout(searchTimeout); vm.searchBusy = false }

      if (query.trim().length < 3) { vm.foundPatients = []; vm.showMinCharLimit = true; return } else { vm.showMinCharLimit = false }

      vm.searchBusy = true

      searchTimeout = setTimeout(() => {
        console.log('searching...')
        vm.$http.get(apiurl + '/patients_query?qo=' + query + '&qa=' + vm.$$.removeDiacritics(query)).then(response => {
          vm.searchBusy = false
          vm.foundPatients = response.body.data
          if (response.body.data.length === 0) { vm.showNothingFound = true } else { vm.showFoundPatientList = true }
        }, response => {
          vm.searchBusy = false
          console.log('Error fetching patients')
        })

        console.log('search', query)
      }, 800)
    },
    onClear: function (event) {
      // var vm = this
      console.log('on clear')
      // vm.showPatientList = true
    },
    onEnable: function (event) {
      var vm = this
      vm.showPatientList = false
    },
    onDisable: function (event) {
      var vm = this
      vm.showPatientList = true
    },
    onInfinite: function (event) {
      var vm = this

      if (loading || !vm.showPatientList) return

      loading = true

      vm.showPreloader = true

      console.log('Loading...')

      vm.$http.get(apiurl + '/patients_paged/' + vm.page).then(response => {
        if (response.body.data.length === 0) { vm.showPreloader = false; return }
        vm.patients.push.apply(vm.patients, response.body.data) // .splice(0, 40)
        vm.page++
        loading = false
      }, response => {
        console.log('Error fetching patients')
        loading = false
      })
    },
    totalProgress (progress, totalBytes, bytesSent) {
      // console.log(progress, totalBytes, bytesSent)
    },
    refresh () {
      var vm = this

      vm.page = 1

      vm.$http.get(apiurl + '/patients_paged/' + vm.page).then(response => {
        vm.patients = response.body.data// .splice(0, 40)
        vm.$$('.page-content.infinite-scroll').scrollTop(0)
        vm.page++
      }, response => {
        console.log('Error fetching patients')
      })
    },
    startExam (examType) {
      var vm = this

      var queryValue;

      if (vm.systemConfig['Integration.Mode'] == 'MWL_PACS') {
          queryValue = vm.barcodeNumber
      } else {
          queryValue = vm.selectedPatient
      }

      var startUroflowmetry = function () {
        vm.$http.get(actionurl + '/inject_input/' + queryValue).then(response => {
          // console.log(response.body)
          if (response.body.err === 'ALREADY_STARTED') {
            vm.$f7.alert('', vm.$t('result_ui.examination_already'))
          } else {
            vm.$f7.alert('', vm.$t('result_ui.examination_started'))
          }
        }, response => {
          console.log('Error starting exam')
        })
      }

      var startUroflowmetryEmg = function () {
        vm.$http.get(actionurl + '/inject_input_emg/' + queryValue).then(response => {
          if (response.body.err === 'ALREADY_STARTED') {
            vm.$f7.alert('', vm.$t('result_ui.examination_already'))
          } else if (response.body.err === 'NOT_READY_EMG' || response.body.err === 'NOT_ENABLED_EMG') {
            vm.$f7.alert('', 'EMG ölçüm için hazır değil')
          } else {
            vm.$f7.alert('', vm.$t('result_ui.examination_started'))
          }
        }, response => {
          console.log('Error starting exam')
        })
      }

      var startUroflowmetryUA = function () {
        vm.$http.get(actionurl + '/inject_input_ua/' + queryValue).then(response => {
          // console.log(response.body)
          if (response.body.err === 'ALREADY_STARTED') {
            vm.$f7.alert('', vm.$t('result_ui.examination_already'))
          } else if (response.body.err === 'NOT_READY_UA' || response.body.err === 'NOT_ENABLED_UA') {
            vm.$f7.alert('', 'İdrar tahlili ölçüm için hazır değil')
          } else if (response.body.err === 'CASETTE_NEEDED') {
            vm.$f7.alert('', 'İdrar tahlili için yeni kaset takmalısınız')
          } else {
            vm.$f7.alert('', vm.$t('result_ui.examination_started'))
          }
        }, response => {
          console.log('Error starting exam')
        })
      }

      var startBiofeedback = function (bioparams) {
        vm.$http.get(actionurl + '/start_biofeedback/' + queryValue).then(response => {
          // console.log(response.body)
          if (response.body.err === 'ALREADY_STARTED') {
            vm.$f7.alert('', vm.$t('result_ui.examination_already'))
          } else if (response.body.err === 'NOT_READY_EMG') {
            vm.$f7.alert('', 'EMG ölçüm için hazır değil')
          } else {
            // vm.$f7.alert('', vm.$t('result_ui.examination_started'))
            // window.open('/#/Biofeedback/' + bioparams, '_blank')
            window.location.href = '/#/Biofeedback/' + bioparams
          }
        }, response => {
          console.log('Error starting exam')
        })
      }

      console.log(examType)

      if (examType == 'URO') {
        vm.$f7.closeModal('#startExamSelection')
        startUroflowmetry()
      } else if (examType == 'UROEMG') {
        vm.$f7.closeModal('#startExamSelection')
        startUroflowmetryEmg()
      } else if (examType == 'UROUA') {
        vm.$f7.closeModal('#startExamSelection')
        startUroflowmetryUA()
      } else if (examType == 'BIO-0') {
        vm.$f7.closeModal('#startExamSelection')
        startBiofeedback('0/0/0')
      } else if (examType == 'BIO-1') {
        vm.$f7.closeModal('#startExamSelection')
        startBiofeedback('1/' + vm.direnme.direnmeZamani + '/' + vm.direnme.dinlenimZamani)
      } else {
        if (vm.systemConfig.EMGEnabled || vm.systemConfig.UAEnabled) {
          vm.$f7.popup('#startExamSelection')
        } else {
          startUroflowmetry()
        }
      }
    },
    startExamType3 () {
      var vm = this
      console.log(vm.selectedPatientNo)
      vm.$http.get(actionurl + '/inject_input/' + vm.selectedPatientNo).then(response => {
        console.log(response.body)
        if (response.body === 'ALREADY_STARTED') {
          vm.$f7.alert('', vm.$t('result_ui.examination_already'))
        } else {
          vm.$f7.alert('', vm.$t('result_ui.examination_started'))
        }
      }, response => {
        console.log('Error starting exam')
      })
    },
    removePatient () {
      var vm = this

      var doRemovePatient = function () {
        vm.$http.delete(apiurl + '/patients/' + vm.selectedPatient).then(response => {
          console.log(response.body)
          vm.selectedPatient = -1
          vm.selectedPatientNo = -1
          vm.selectedPatientStr = ''
          vm.exams = []
          vm.refresh()
        }, response => {
          console.log('Error removing patient')
        })
      }
      
      vm.$f7.confirm('', vm.$t('result_ui.remove_patient_warning', {patient: vm.selectedPatientStr}), doRemovePatient)
    },
    removeExam () {
      var vm = this

      var doDeleteExam = function () {
        vm.$http.delete(apiurl + '/exams/' + vm.exam_detail.id).then(response => {
          console.log(response.body)
          vm.selectedPatient = -1
          vm.selectedPatientNo = -1
          vm.selectedPatientStr = ''
          vm.exams = []
          vm.refresh()
        }, response => {
          console.log('Error deleting exam')
        })
      }

      vm.$f7.confirm('', vm.$t('result_ui.delete_exam_warning'), doDeleteExam)
    },
    printBarcode () {
      var vm = this
      vm.$http.get(printurl + '/' + vm.selectedPatient).then(response => {
        console.log(response.body)
        if (response.body === 'PRINTED') {
          vm.$f7.alert('', vm.$t('result_ui.barcode_printed'))
        }
      }, response => {
        console.log('Barkod basılırken hata oluştu')
      })
    },
    printBarcodePopup () {
      var vm = this
      var newwindow = window.open(staticurl + '/printBarcode.html?n=' + vm.selectedPatientNo + '&r=' + Math.random(), 'printBarcodePopup', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes,height=500,width=500')
      if (window.focus) { newwindow.focus() }
    },
    fetchPatient () {
      var vm = this

      if (vm.newPatient.hastaNo !== undefined) {
        vm.$http.get(apiurl + '/hospital_patient/' + vm.newPatient.hastaNo).then(response => {
          if (response.body.data.length === 0) {
            vm.newPatientForm.patientDisabled = false
            vm.newPatient.nameSurname = undefined
            vm.newPatient.birthDate = undefined
            vm.newPatient.gender = 1
            vm.newPatientForm.nsPlaceholder = vm.$t('result_ui.enter_name_surname')
          } else {
            var pat = response.body.data[0]
            vm.newPatient.nameSurname = pat.name + ' ' + pat.surname
            vm.newPatient.birthDate = pat.birth_date
            vm.newPatient.gender = pat.gender
            vm.newPatientForm.patientDisabled = true
          }
        }, response => {
          console.log('Error fetching patients')
        })
      }
    },
    getPatientInfo(selectedPatient) {
      var vm = this

      if (selectedPatient != undefined) {
        vm.$http.get(apiurl + '/patient_info/' + selectedPatient).then(response => {
          var pat = response.body.data[0]
          if (response.body.data.length == 0) {
            vm.patient.name = 'No Nmae'
            vm.patient.surname = 'No Surname'
            vm.patient.gender = 'Female'
            vm.patient.birthDate = ''
          }
          else {
            vm.patient.name = pat.name
            vm.patient.surname = pat.surname
            vm.patient.gender = pat.gender
            vm.patient.birthDate = pat.birth_date
          }
        })
      }
      else {
        console.log('No patient (id) selected.')
      }

    },
    saveComment () {
      var vm = this
      vm.$http.put(apiurl + '/exam', {id: vm.exam_detail.id, comment: vm.comment}).then(response => {
        console.log(response.body)
        // vm.newPatient = {nameSurname: '', gender: 1, birthDate: '', protokolNo: undefined, hastaNo: undefined, doctor: -1}
        // vm.refresh()
        vm.exam_detail.comment = vm.comment
        vm.getExamList(vm.selectedPatient, vm.selectedPatientStr, vm.selectedPatientNo)
        vm.$f7.closeModal('#addComment')
      }, response => {
        console.log('Error saving comment')
      })
    },
    createPatientHospital () {
      var vm = this

      if (!vm.newPatient.hastaNo || !vm.newPatient.protokolNo || !vm.newPatient.nameSurname || !vm.newPatient.birthDate) {
        window.alert(vm.$t('result_ui.fill_all'))
        return
      }

      if (!isValidDate(vm.newPatient.birthDate)) {
        window.alert(vm.$t('result_ui.date_warning'))
        return
      }

      vm.$http.put(apiurl + '/hospital_patient', vm.newPatient).then(response => {
        console.log(response.body)
        vm.newPatient = {nameSurname: '', gender: 1, birthDate: '', protokolNo: undefined, hastaNo: undefined, doctor: -1}
        vm.refresh()
        vm.$f7.closeModal('#addNewPopupHospital')
      }, response => {
        console.log('Error creating patient')
      })
    },
    updatePatient () {
      var vm = this

      if (!vm.patient.name || !vm.patient.surname || !vm.patient.birthDate || !vm.patient.gender) {
        window.alert(vm.$t('result_ui.fill_all'))
        return
      }

      if (!isValidDate(vm.patient.birthDate)) {
        window.alert(vm.$t('result_ui.date_warning'))
        return
      }

      vm.$http.put(apiurl + '/patient_info_update/' + vm.selectedPatient, vm.patient).then(response => {
        vm.selectedPatientStr = vm.patient.name + " " + vm.patient.surname
        vm.patient = {name: '', surname: '', gender: 1, birthDate: ''}  
        vm.refresh()
        vm.$f7.closeModal('#editPatient')
      }, response => {
        console.log('Error updating patient info')
      })
    },
    createPatient () {
      var vm = this

      if (!vm.newPatient.name || !vm.newPatient.surname || !vm.newPatient.birthDate) {
        window.alert(vm.$t('result_ui.fill_all'))
        return
      }

      if (!isValidDate(vm.newPatient.birthDate)) {
        window.alert(vm.$t('result_ui.date_warning'))
        return
      }

      vm.$http.put(apiurl + '/patients', vm.newPatient).then(response => {
        // window.alert(response)
        console.log(response.body)
        vm.newPatient = {name: '', surname: '', gender: 1, birthDate: ''}
        vm.refresh()
        vm.$f7.closeModal('#addNewPopupFree')
      }, response => {
        // window.alert('ERR')
        // window.alert(JSON.stringify(response))
        console.log('Error creating patient')
      })
    },
    createPatientFree2 () {
      var vm = this

      if (!vm.newPatient.name || !vm.newPatient.surname || !vm.newPatient.birthDate || !vm.newPatient.hastaNo) {
        window.alert(vm.$t('result_ui.fill_all'))
        return
      }

      if (!isValidDate(vm.newPatient.birthDate)) {
        window.alert(vm.$t('result_ui.date_warning'))
        return
      }

      vm.$http.put(apiurl + '/patients_free', vm.newPatient).then(response => {
        // window.alert(response)
        console.log(response.body)
        vm.newPatient = {name: '', surname: '', gender: 1, birthDate: '', hastaNo: undefined}
        vm.refresh()
        vm.$f7.closeModal('#addNewPopupFree2')
      }, response => {
        // window.alert('ERR')
        // window.alert(JSON.stringify(response))
        console.log('Error creating patient')
      })
    },
    createPatientType3 () {
      var vm = this

      if (!vm.newPatient.hastaNo) {
        window.alert(vm.$t('result_ui.fill_all'))
        return
      }

      vm.$http.put(apiurl + '/patient_type_3', vm.newPatient).then(response => {
        console.log(response.body)
        if (response.body === 'EXISTS') window.alert(vm.$t('result_ui.patient_exists'))
        vm.newPatient = {hastaNo: undefined}
        vm.refresh()
        vm.$f7.closeModal('#addNewPopupType3')
      }, response => {
        console.log('Error creating patient')
      })
    },
    complete (file, status, xhr) {
      // Adding server id to be used for deleting
      // the file.
      // file.addAttribute('id', xhr.response.id)
      console.log('uploaded.')
      window.open('/#/integrated-report/' + this.exam_detail.id + '?print=yes')
    },
    getFileName (event) {
      console.log(event)
      this.filename = event.target.files[0].name
      this.fileSelected = true
      document.getElementById('fileSender').submit()
    },
    getExamList (patientId, patientStr, patientNo) {
      var vm = this

      // vm.chartOpened = true

      vm.selectedPatient = patientId
      vm.selectedPatientStr = patientStr
      vm.selectedPatientNo = patientNo

      vm.$http.get(apiurl + '/patients/' + patientId).then(response => {
        vm.exams = response.body.data
      }, response => {
        console.log('Error fetching examination list')
      })

      if (vm.systemConfig['Integration.AddPatientMode'] == 'Hospital') {
        vm.$http.get(apiurl + '/unused_barcodes/' + patientId).then(response => {
          vm.barcodes = response.body.data
        }, response => {
          console.log('Error fetching barcode list')
        })
      }
    },
    printPdf () { window.open('/print.html#/printout/' + this.exam_detail.id + '?print=yes') },
    savePVR () {
      var vm = this

      vm.pvrBusy = true

      vm.$http.put(apiurl + '/add_pvr/' + vm.exam_detail.id, {pvr: vm.pvr}).then(response => {
        console.log(response.body)
        vm.exam_detail.pvr = vm.pvr
        vm.pvr = undefined
        // vm.newPatient = {nameSurname: '', gender: 1, birthDate: '', protokolNo: undefined, hastaNo: undefined}
        // vm.refresh()
        // vm.$f7.closeModal('#addNewPopupHospital')
        vm.getExamList(vm.selectedPatient, vm.selectedPatientStr, vm.selectedPatientNo)
      }, response => {
        console.log('Error creating patient')
      })

      setTimeout(() => {
        vm.pvrBusy = false
      }, 10000)

      console.log('gonna save pvr..')
      console.log(vm.exam_detail.id)
    },
    chartPopupClosed () {
      var vm = this
      vm.exam_detail.max_speed = undefined
      vm.exam_detail.max_speed_time = undefined
      vm.exam_detail.total_volume = undefined
      vm.exam_detail.duration = undefined
      vm.exam_detail.flow_time = undefined
      vm.exam_detail.delay_time = undefined
      vm.exam_detail.average_speed = undefined
      vm.exam_detail.created = undefined
      vm.exam_detail.pvr = undefined
      vm.pvrBusy = false
      vm.exam_detail.comment = undefined
      vm.exam_detail.ua_status = undefined
    },
    deviceScreen () {
      window.location.href = '/#/Device'
    },
    showChart (exam) {
      var vm = this

      var chartConfig = {

        width: 800,
        height: 380,
        margin: { top: 8, bottom: 21, left: 75, right: 10 },
        interpolation: 'monotone',
        tickInterval: 1000,
        orientation: 'horizontal',
        axisLabels: 'enabled',
        // tickEvery: 5,
        chartType: 'static',
        invisible_points: 0,
        totalTime: 19000,
        translation: vm.$t,
        EMGEnabled: true,

        tickConfig: {
          verticalTicks: true
        },
        lineStrokeWidth: 1.5 // should match css "stroke-width"
      }

      vm.historyChart = new GenericChart(document.querySelector('svg'), chartConfig)

      vm.$f7.popup('#chartPopup') // opening and closing via state (like vm.chartPopupOpened = true) does not work in second try. it may be passing removeOnClose = true
      vm.comment = exam.comment

      // console.log(exam)

      var w = []
      var s = []
      var e = []

      if (exam.weight_array) {
        w = exam.weight_array.split(' ').map(function (item) { return parseFloat(item, 10) })
        s = exam.speed_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      if (exam.emg_array) {
        e = exam.emg_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      var weight = []
      var speed = []
      var emg = []

      for (let i = 0; i < w.length; i++) {
        let t = new Date(i * 1000)
        weight.push([t, w[i]])
        speed.push([t, s[i]])
      }

      for (let i = 0; i < e.length; i++) {
        let t = new Date(i * 100)
        emg.push([t, e[i]])
      }

      vm.exam_detail.id = exam.id

      if (exam.weight_array) {
        vm.exam_detail.max_speed_time = exam.max_speed_time
        vm.exam_detail.duration = exam.duration
        vm.exam_detail.flow_time = exam.flow_time
        vm.exam_detail.delay_time = exam.delay_time
        vm.exam_detail.created = exam.created

        vm.exam_detail.max_speed = exam.max_speed.toFixed(1)
        vm.exam_detail.average_speed = exam.average_speed.toFixed(1)
        vm.exam_detail.total_volume = exam.total_volume.toFixed(1)
        if (exam.pvr != undefined) vm.exam_detail.pvr = exam.pvr.toFixed(1)
        vm.exam_detail.comment = exam.comment
        vm.exam_detail.ua_status = exam.ua_status
      }

      // console.log(weight);
      // console.log(speed);

      // chartDialog.showModal()

      // vm.historyChart = new GenericChart(document.querySelector('svg'), )
      vm.historyChart.initDrawing(weight, speed, emg, vm.systemConfig['Chart.Scale'], vm.systemConfig['EMG.Chart.Scale'])

      if (exam.emg_array && weight.length) {
        console.log('Duration (sec):', weight.length - 1)
        console.log('Uroflowmetry+EMG result.')
        vm.show_uroflowmetry = true
        vm.historyChart.emgEnable(true)
      } else if (exam.emg_array && !weight.length) {
        console.log('Duration (sec):', exam.emg_array.length - 1)
        console.log('EMG result.')
        vm.show_uroflowmetry = false
        vm.historyChart.emgEnable(true, true)
      } else {
        console.log('Duration (sec):', weight.length - 1)
        console.log('Uroflowmetry result.')
        vm.show_uroflowmetry = true
        vm.historyChart.emgEnable(undefined, false)
      }
    }
  }
}

</script>

<style>
@import url('./assets/fonts/catamaran/catamaran.css');

.dev-box-app {
  font-family: Arial, Helvetica, sans-serif;
  z-index: 1000;
  font-size: 14px;
  text-align: left;
  background-color:#eee;
}

.dev-box-app li { padding-bottom: 5px; }

.dev-box-app a {
  text-decoration:none;
  color:blue;
  padding-left:10px;
}

.dev-box-app a:hover {
  color:#FF2B39;
}

.selectedPatient {
  background-color: #ddd;
}
#app_f7 .view-left {
  float: left;
  width: 400px;
  border-right: 1px solid #b2b2b2;
}
#app_f7 .view-main {

  width: -webkit-calc(100% - 401px);
  width: -moz-calc(100% - 401px);
  width: -ms-calc(100% - 401px);
  width: calc(100% - 401px);
}
@media (max-width: 768px) {
  #app_f7 .view-left {
    width: 240px;
  }
  #app_f7 .view-main {
    width: -webkit-calc(100% - 241px);
    width: -moz-calc(100% - 241px);
    width: -ms-calc(100% - 241px);
    width: calc(100% - 241px);
  }
}




/*
ul > li { border-bottom: solid 1px #000; }

ul > li.list-link:hover { background-color: #e6f7ff; cursor:pointer }
ul > li.list-link:hover i.left-icon { background-color: #009de6; }
ul > li.list-link:hover i.right-icon { color: #009de6; }


ul > li.active { background-color: #e6f7ff; cursor:pointer }
ul > li.active i.left-icon { background-color: #009de6; }
ul > li.active i.right-icon { color: #009de6; }
*/

/*
.examInfo {
  
}

.examInfo td:first-child {
  
  width:110px;
  text-decoration: underline;
}

.examInfo td:last-child {
  
}
*/
#chartHistory {
  margin-top:10px;
}

#chartHistory .axis {
  font: 10px sans-serif;
}


#chartHistory .axis path,
#chartHistory .axis line1, #chartHistory .axis line2, #chartHistory .axis line3 {
  fill: none;
  stroke: #dfdfdf;
  shape-rendering: crispEdges;
}

#chartHistory .axis--x line, #chartHistory .axis--y1 line, #chartHistory .axis--y2 line, #chartHistory .axis--y3 line {
  stroke: #dfdfdf;
}

#chartHistory .axis--y1 .tick:nth-last-child(3) text, #chartHistory .axis--y2 .tick:nth-last-child(3) text, #chartHistory .axis--y3 .tick:nth-last-child(3) text {
  transform: translate(0px, 7px);
  visibility: visible;
}

#chartHistory .axis--y1 .tick:first-child text, #chartHistory .axis--y2 .tick:first-child text, #chartHistory .axis--y3 .tick:first-child text {
  transform: translate(0px, -7px);
  visibility: visible;
}

#chartHistory .line1, #chartHistory .line2, #chartHistory .line3 {
  fill: none;
  stroke: steelblue;
  stroke-width: 1.5px;
}

#chartHistory .line3 { stroke: none; }

/* #chartHistory .area { fill: none; } */
#chartHistory .area { fill: black; }

.exam-links { width:40%; padding-right:60px; text-align:right; float:right; }
.exam-links a { margin-left: 30px; }
.exam-links a:hover { color:black; }

</style>



// WEBPACK FOOTER //
// src/App_f7.vue